import { ReactNode } from 'react'
import { Stack, StackProps } from '@mui/material'

export interface CardAccordionTitleProps extends Omit<StackProps, 'children' | 'title'> {
  icon?: ReactNode
  title?: ReactNode
}

export default function CardAccordionTitle({ icon, title, ...props }: CardAccordionTitleProps) {
  return (
    <Stack direction="row" alignItems="center" gap={2} {...props}>
      {icon}
      <span>{title}</span>
    </Stack>
  )
}
